import React, { useState } from 'react';
import { Typography, Button, Box } from '@mui/material';
import {
  Settings,
  People,
  Logout,
  AccountCircle,
  Assessment,
  Build,
  Payments,
  Business,
  Category,
  ReceiptLong,
  Description,
  NotificationsActive,
  Security,
  SwapHoriz,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useContext } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import UserManagement from '../../components/admin/UserManagement';
import UserSettings from '../../components/UserSettings';
import Reports from '../../components/reports/Reports';
import LandlordManagement from '../../components/admin/LandlordManagement';
import CompanyInfo from '../../components/admin/CompanyInfo';
import ExpenseCategoryManagement from '../../components/admin/ExpenseCategoryManagement';
import IncomeCategoryManagement from '../../components/admin/IncomeCategoryManagement';
import ChargeTypeManagement from '../../components/admin/ChargeTypeManagement';
import RepairCategoryManagement from '../../components/admin/RepairCategoryManagement';
import PaymentModeManagement from '../../components/admin/PaymentModeManagement';
import NoticeCategoryManagement from '../../components/admin/NoticeCategoryManagement';
import RolePermissions from '../../components/admin/RolePermissions';
import ReminderRouting from '../../components/admin/ReminderRouting';

const NAV_ITEMS = [
  { icon: <People />, label: 'User Management', Component: UserManagement },
  { icon: <Security />, label: 'Role Permissions', Component: RolePermissions },
  { icon: <Business />, label: 'Landlord Management', Component: LandlordManagement },
  { icon: <Settings />, label: 'Company Info', Component: CompanyInfo },
  { icon: <Category />, label: 'Expense Categories', Component: ExpenseCategoryManagement },
  { icon: <Category />, label: 'Income Categories', Component: IncomeCategoryManagement },
  { icon: <ReceiptLong />, label: 'Charge Types', Component: ChargeTypeManagement },
  { icon: <Build />, label: 'Repair Categories', Component: RepairCategoryManagement },
  { icon: <Payments />, label: 'Payment Modes', Component: PaymentModeManagement },
  { icon: <Description />, label: 'Notice Categories', Component: NoticeCategoryManagement },
  { icon: <NotificationsActive />, label: 'Reminder Routing', Component: ReminderRouting },
  { icon: <Assessment />, label: 'Reports', Component: Reports },
  { icon: <AccountCircle />, label: 'Account Settings', Component: UserSettings },
];

const AdminPanel = () => {
  const [tabValue, setTabValue] = useState(0);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  // Wait for the cookie to actually be cleared before leaving, and replace the history
  // entry so Back from the login screen does not step into the signed-out dashboard.
  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <DashboardLayout
      title="Admin Panel"
      navItems={NAV_ITEMS}
      activeIndex={tabValue}
      onSelect={setTabValue}
      headerActions={
        <>
          <Button color="inherit" onClick={() => navigate('/staff')} startIcon={<SwapHoriz />} sx={{ mr: { xs: 0.5, sm: 2 }, minWidth: 0, px: { xs: 1, sm: 2 } }}>
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Staff Portal</Box>
          </Button>
          <Typography variant="body2" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>
            {user?.name}
          </Typography>
          <Button color="inherit" onClick={handleLogout} startIcon={<Logout />} sx={{ minWidth: 0, px: { xs: 1, sm: 2 } }}>
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Logout</Box>
          </Button>
        </>
      }
    />
  );
};

export default AdminPanel;

